// extracted by mini-css-extract-plugin
export var blockedMessage = "_bz-3";
export var blockedOverlay = "_bz-1";
export var fadeIn = "_bz-2";
export var hereLink = "_bz-0";
export var slideUp = "_bz-4";